"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montoro": {
    "ffafcff0": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "aterrana": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6248759d": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "caliano": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52860129": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "chiusa-sant-eustacchio": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f90d3d73": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "figlioli": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1563b15": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "montoro-inferiore": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1a653e2": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "montoro-superiore": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "70bd2705": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "preturo": [{
      "hkey": "06f324fc",
      "slug": "montoro",
      "name": "Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;